import { styled } from '@glitz/react';

export default styled.p({
  font: {
    weight: 300,
    size: '16px',
  },
});
